//src/components/NewTaskReminder.tsx
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { createTaskReminder } from '../../utils/api';
import { TaskReminder } from '../../utils/types';

interface NewTaskReminderProps {
    onCreated: (newTaskReminder: TaskReminder) => void;
    onClose: () => void;
}

const getDefaultReminderTime = () => {
    const now = new Date();
    now.setHours(now.getHours() + 24); // Add 24 hours
    // Format to YYYY-MM-DDTHH:MM, which is required by datetime-local input
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const NewTaskReminder: React.FC<NewTaskReminderProps> = ({ onCreated, onClose }) => {
    const { t } = useTranslation();

    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [reminderAt, setReminderAt] = useState<string>(getDefaultReminderTime());
    const [loading, setLoading] = useState<boolean>(false);

    const handleCreate = async () => {
        if (!title || !reminderAt) {
            // toast.error(t('taskReminder.fillAllFields'));
            return;
        }

        setLoading(true);
        try {
            const newTaskReminder: TaskReminder = await createTaskReminder({
                title,
                description,
                reminder_at: reminderAt,
            });

            // console.log('newTaskReminder', newTaskReminder);

            // toast.success(t('taskReminder.createdSuccess'));
            onCreated(newTaskReminder);
            onClose();
        } catch (error) {
            // toast.error(t('taskReminder.createdError'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-4">
            {/* <h2 className="text-lg font-bold mb-4">{t('taskReminder.newTaskReminder')}</h2> */}
            <div className="mb-4 text-xs">
                <label className="block mb-1">{t('taskReminder.title')}</label>
                <input
                    type="text"
                    className="w-full border border-gray-600 px-2 py-1 bg-gray-200 rounded-md"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>
            <div className="mb-4 text-xs">
                <label className="block mb-1">{t('taskReminder.description')}</label>
                <textarea
                    className="w-full border border-gray-600 px-2 py-1 bg-gray-200 h-50 overflow-y-scroll max-h-50 resize-none rounded-md"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>
            <div className="mb-4 text-xs">
                <label className="block mb-1">{t('taskReminder.reminderAt')}</label>
                <input
                    type="datetime-local"
                    className="w-full border border-gray-600 px-2 py-1 bg-gray-200 rounded-md"
                    value={reminderAt}
                    onChange={(e) => setReminderAt(e.target.value)}
                />
            </div>
            <div className="flex justify-end space-x-2">
                {/* <button
                    className="px-4 py-2 bg-gray-300 rounded"
                    onClick={onClose}
                    disabled={loading}
                >
                    {t('taskReminder.cancel')}
                </button> */}
                <button
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                    onClick={handleCreate}
                    disabled={loading}
                >
                    {loading ? t('taskReminder.creating') : t('taskReminder.newTaskReminder')}
                </button>
            </div>
        </div>
    );
};

export default NewTaskReminder;